// Transport des retours lecteurs : `POST /api/avis`, relayé par nginx vers le
// service serveur/serveur.mjs, qui envoie le courriel par Brevo. La page ne
// détient aucun secret ; elle ne fait que transmettre le formulaire.

import type { Avis } from "../avis";

export const URL_AVIS = "/api/avis";

/**
 * Ce que la page doit dire après l'envoi :
 *   envoye       — le courriel est parti ;
 *   indisponible — le service n'est pas là ou pas configuré : la page propose la messagerie ;
 *   trop         — trop d'envois rapprochés ;
 *   refuse       — le serveur rejette le contenu, avec la raison.
 */
export type ResultatEnvoi =
  | { etat: "envoye" }
  | { etat: "indisponible" }
  | { etat: "trop" }
  | { etat: "refuse"; raison: string };

export async function envoyerAvis(
  avis: Avis,
  version: string,
  /** Champ piège du formulaire, vide pour un humain. */
  piege = "",
  faireFetch: typeof fetch = fetch,
): Promise<ResultatEnvoi> {
  let reponse: Response;
  try {
    reponse = await faireFetch(URL_AVIS, {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ ...avis, version, piege }),
    });
  } catch {
    return { etat: "indisponible" };
  }
  if (reponse.ok) return { etat: "envoye" };
  if (reponse.status === 429) return { etat: "trop" };
  if (reponse.status === 400 || reponse.status === 413) {
    const corps = (await reponse.json().catch(() => null)) as { erreur?: unknown } | null;
    return {
      etat: "refuse",
      raison: typeof corps?.erreur === "string" ? corps.erreur : "Message refusé.",
    };
  }
  // 404 (pas de service, en développement), 502, 503 (pas de clé) : on n'insiste pas.
  return { etat: "indisponible" };
}
